import React from "react";
import classNames from "classnames";
import { CriyaLogo } from "../logos/CriyaLogo";

type Props = {
  children: React.ReactNode;
  onClickLogo?: () => void;
};

export const Sidebar: React.FC<Props> = ({ children, onClickLogo }) => {
  return (
    <div className={classNames("w-64 border-r border-light-neutral-2 flex flex-col bg-white")}>
      <div
        className={classNames("py-5 px-8", onClickLogo ? "cursor-pointer" : "")}
        onClick={onClickLogo}
      >
        <CriyaLogo />
      </div>
      <div className={classNames("flex flex-col gap-3")}>{children}</div>
    </div>
  );
};
